export default __webpack_public_path__ + "static/media/explore_destination_img.676aa78d.jpg";